export const notifications = {
    'TYPE_TRAIN_VERSION_QUEUE': { label: 'Entrainement en attente', },
    'TYPE_TRAIN_VERSION_START': { label: 'Entrainement démarré', },
    'TYPE_TRAIN_VERSION_DONE': { label: 'Entrainement terminé', },
    'TYPE_TRAIN_VERSION_CANCEL': { label: 'Entrainement annulé', },
};

export default notifications;
